import ApplicationAdapter from './application';

export default class ThoughtBubbleStepAdapter extends ApplicationAdapter {
  namespace = 'api/v2';
}
